//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default {
        name: 'maternal_service',
        data (){
            return {
                buttonTabVal: 0,
                base_info:{
                    id: this.$route.query.id,
                    member_id: '', // 会员ID，从用户基本信息中获取
                    name:'',
                    phone: '',
                    package: '',
                    macheck_id:'',
                    leave_id:'',//出院
                    checklist_id:'',//月子期间医院就诊单
                    order_total_id: '' //订单ID
                },
                baby_list:[]
            }
        },
        methods: {
            toFormEight(item){
                console.info(item)
                if(item.live_time=='0'){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '该宝宝未入住',
                    })
                    return
                }
                if(item.foot_id==''){
                    this.$router.push({
                        path:'./christmas_form_eight',
                        query:{
                            id:this.base_info.id,
                            child_id:item.id,
                            tabVal:this.buttonTabVal,
                        }
                    })
                }else{
                     this.$router.push({
                        path:'./christmas_form_eight_detail',
                        query:{
                            id:this.base_info.id,
                            child_id:item.id,
                            tabVal:this.buttonTabVal
                        }
                    })
                }
            },
            toFormE(item){
                // :link="item.ch_id==''?'./bb_form_e?id='+ base_info.id+'&child_id='+item.id +'&tabVal=' + buttonTabVal 
                // : './bb_form_e_detail?id='+ base_info.id + '&form_id='+item.ch_id+'&child_id='+item.id +'&tabVal=' + buttonTabVal "
                console.info(item)
                if(item.live_time=='0'){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '该宝宝未入住',
                    })
                    return
                }
                if(item.ch_id==''){
                    this.$router.push({
                        path:'./bb_form_e',
                        query:{
                            id:this.base_info.id,
                            child_id:item.id,
                            tabVal:this.buttonTabVal,
                            baby_name:item.name,
                            baby_sex:item.sex=='1'?'男':'女'
                        }
                    })
                }else{
                     this.$router.push({
                        path:'./bb_form_e_detail',
                        query:{
                            id:this.base_info.id,
                            form_id:item.ch_id,
                            child_id:item.id,
                            tabVal:this.buttonTabVal
                        }
                    })
                }
            },
            toFormD(item){
            //     link="item.full_id==''?'./bb_form_d?id='+ base_info.id+'&child_id='+item.id +'&tabVal=' + buttonTabVal : 
            //    './bb_form_d_detail' +'?id='+ base_info.id + '&form_id='+item.full_id+'&child_id='+item.id +'&tabVal=' + buttonTabVal " 
                console.info(item)
                if(item.live_time=='0'){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '该宝宝未入住',
                    })
                    return
                }
                if(item.full_id==''){
                    this.$router.push({
                        path:'./bb_form_d',
                        query:{
                            id:this.base_info.id,
                            child_id:item.id,
                            tabVal:this.buttonTabVal,
                            baby_name:item.name,
                            baby_sex:item.sex=='1'?'男':'女'
                        }
                    })
                }else{
                     this.$router.push({
                        path:'./bb_form_d_detail',
                        query:{
                            id:this.base_info.id,
                            form_id:item.full_id,
                            child_id:item.id,
                            tabVal:this.buttonTabVal
                        }
                    })
                }
            },
            //tab切换
            tabChange(index){
                this.buttonTabVal = index
            },
             toSpecial(){
                // 打印 base_info 的全部信息
                console.log('base_info 全部信息：', this.base_info);
                console.log('base_info.member_id：', this.base_info.member_id);
                console.log('base_info.id：', this.base_info.id);
                console.log('base_info.name：', this.base_info.name);
                console.log('base_info.phone：', this.base_info.phone);
                console.log('base_info.order_total_id：', this.base_info.order_total_id);
                
                this.$router.push({
                    path: './maternal_special',
                    query: {
                        id: this.$route.query.id,              // route.query.id 是 maternal_info_id
                        member_id: this.base_info.member_id,    // member_id 从用户基本信息中获取
                        tabVal: this.buttonTabVal,
                        maternal_info_id: this.$route.query.id, // maternal_info_id 就是 route.query.id
                        store_id: this.$cookie.get('store_id'), // 从 Cookie 获取 store_id
                        order_total_id: this.base_info.order_total_id || '', // 从 base_info 获取 order_total_id
                    }
                });
    },
            toSpecialRoom(){
                // 打印 base_info 的全部信息
                console.log('base_info 全部信息：', this.base_info);
                console.log('base_info.member_id：', this.base_info.member_id);
                console.log('base_info.id：', this.base_info.id);
                console.log('base_info.name：', this.base_info.name);
                console.log('base_info.phone：', this.base_info.phone);
                console.log('base_info.order_total_id：', this.base_info.order_total_id);
                
                this.$router.push({
                    path: './maternal_special_room',
                    query: {
                        id: this.$route.query.id,              // route.query.id 是 maternal_info_id
                        member_id: this.base_info.member_id,    // member_id 从用户基本信息中获取
                        tabVal: this.buttonTabVal,
                        maternal_info_id: this.$route.query.id, // maternal_info_id 就是 route.query.id
                        store_id: this.$cookie.get('store_id'), // 从 Cookie 获取 store_id
                        order_total_id: this.base_info.order_total_id || '', // 从 base_info 获取 order_total_id
                    }
                });
    },
            toSpecialMeal(){
                // 打印 base_info 的全部信息
                console.log('base_info 全部信息：', this.base_info);
                console.log('base_info.member_id：', this.base_info.member_id);
                console.log('base_info.id：', this.base_info.id);
                console.log('base_info.name：', this.base_info.name);
                console.log('base_info.phone：', this.base_info.phone);
                console.log('base_info.order_total_id：', this.base_info.order_total_id);
                
                this.$router.push({
                    path: './maternal_special_meal',
                    query: {
                        id: this.$route.query.id,              // route.query.id 是 maternal_info_id
                        member_id: this.base_info.member_id,    // member_id 从用户基本信息中获取
                        tabVal: this.buttonTabVal,
                        maternal_info_id: this.$route.query.id, // maternal_info_id 就是 route.query.id
                        store_id: this.$cookie.get('store_id'), // 从 Cookie 获取 store_id
                        order_total_id: this.base_info.order_total_id || '', // 从 base_info 获取 order_total_id
                    }
                });
    },
            get_baby_list (){
                this.$vux.loading.show({
                    text: '正在加载'
                })
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.monthLiveApi.babyList(params).then ( res => {
                    console.info('宝宝基本信息',res)
                    if(res.errcode == 1){
                        this.baby_list = res.data
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求用户基本信息
            apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info('用户基本信息',res)
                    console.info('用户基本信息 - 完整返回数据:', JSON.stringify(res.data, null, 2))
                    if(res.errcode == 1){
                        this.base_info.member_id = res.data.member_id || res.data.id || '' // 会员ID
                        this.base_info.name = res.data.name
                        this.base_info.phone = res.data.phone
                        this.base_info.package = res.data.package_name
                        this.base_info.macheck_id = res.data.macheck_id
                        this.base_info.leave_id = res.data.leave_id
                        this.base_info.checklist_id = res.data.checklist_id
                        this.base_info.order_total_id = res.data.order_total_id
                        // // 检查是否有 order_total_id
                        // if(res.data.order_total_id){
                        //     this.base_info.order_total_id = res.data.order_total_id
                        //     console.info('找到 order_total_id:', res.data.order_total_id)
                        // } else {
                        //     console.warn('API 返回数据中没有 order_total_id 字段')
                        //     console.info('API 返回的所有字段:', Object.keys(res.data))
                        // }
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            goBack(){
                this.$router.push({
                    path: './maternal_file'
                })
            }
        },
        created(){
            this.get_baby_list()
            this.apiMemberInfo()
            for(let i=0; i<4; i++){
                if(this.$route.query.tabVal == i){
                    this.buttonTabVal = i
                }
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/maternal_service.vue